import {createContext, useContext} from 'react';
import {
  getElevationValue,
  type ElevationType,
} from '@spaced-out/ui-design-system';

/**
 * Base z-index the ask-ai panel renders at. UDS overlays (menus, tooltips)
 * portal to <body> and use elevation tokens capped at 60, so inside the panel —
 * which sits far higher (DEFAULT_ASK_AI_ELEVATION = 2000) — they'd paint
 * underneath it. Descendants add this base to their token via `useElevation`
 * so overlays land above the panel while keeping the tokens' relative order.
 *
 * Default 0 = no panel: overlays keep their plain token z-index.
 */
export const ElevationBaseContext = createContext(0);

/**
 * Returns an `elevation` value for a UDS overlay, shifted above the panel base.
 * Outside a panel (base 0) it returns the token's own z-index unchanged.
 * The numeric string is cast to ElevationType because UDS passes any value it
 * doesn't recognize straight through to the z-index CSS variable.
 */
export function useElevation(token: ElevationType): ElevationType {
  const base = useContext(ElevationBaseContext);
  const offset = parseInt(getElevationValue(token), 10) || 0;
  return String(base + offset) as ElevationType;
}
